export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

export function formatPhone(phone: string): string {
  // If already formatted, return as-is
  if (phone.includes('(')) return phone;

  // Remove all non-digits
  const digits = phone.replace(/\D/g, '');

  // Format as (XXX) XXX-XXXX
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return phone;
}

export function formatPhoneInput(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function formatPercentage(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatStatus(status: string): string {
  if (status === 'superseded') return 'Superseded';
  return status
    .split('_')
    .map(word => capitalizeFirst(word))
    .join(' ');
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'confirmed':
      return '#10b981'; // Green
    case 'pending':
    case 'pending_payment':
      return '#f59e0b'; // Yellow/Orange
    case 'checked_in':
      return '#3b82f6'; // Blue
    case 'checked_out':
      return '#6b7280'; // Gray
    case 'cancelled':
      return '#ef4444'; // Red
    case 'superseded':
      return '#a927f5'; // Purple (modified reservation)
    default:
      return '#6b7280'; // Gray
  }
}

export function getReservationReviewClass(rating: number, wouldWelcomeBack: boolean): string {
  if (rating === 1 && !wouldWelcomeBack) return 'reservation-item--restricted';
  if (rating <= 2 || !wouldWelcomeBack) return 'reservation-item--be-aware';
  return '';
}

export function getPaymentStatusColor(status: string): string {
  switch (status) {
    case 'paid':
      return '#10b981'; // Green
    case 'partial':
      return '#f59e0b'; // Yellow/Orange
    case 'pending':
      return '#ef4444'; // Red
    case 'refunded':
      return '#6b7280'; // Gray
    default:
      return '#6b7280'; // Gray
  }
}
